import { Divider, IconButton } from '@material-ui/core';
import CheckBoxOutlined from '@material-ui/icons/CheckBoxOutlineBlank';
import Checkbox from '@material-ui/icons/CheckBoxOutlined';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import React from 'react';
import styled from 'styled-components';
import Utils from '../../Utils';


const SubHeader = styled.div`
padding-top:10px;
display:grid;
grid-template-columns:24px  minmax(100px,200px) minmax(100px,360px) 64px 64px 128px 44px  minmax(0px,44px);
padding-left:10px;
padding-right:10px;
padding-bottom:10px;
align-items:center;


`;

const SubHeaderText = styled.div`
color: black;
font-family: Roboto;
font-size: 14px;
font-weight: 400;
line-height: 19px;
text-align: left;
`;


class ProjectProceduresListItem extends React.Component {


    render() {
        const {procedure = {}} = this.props;
        const {iwpp,name,rev,effectiveDate,url,sdn} = procedure;
        return ( 
                <div>
                <SubHeader>
                    <div/>
                    <SubHeaderText>{sdn}</SubHeaderText>
                    <SubHeaderText>{name}</SubHeaderText>
                    <SubHeaderText>{iwpp ? <Checkbox/> : <CheckBoxOutlined/>}</SubHeaderText>
                    <SubHeaderText>{rev}</SubHeaderText>
                    <SubHeaderText>{Utils.formatDate(effectiveDate)}</SubHeaderText>
                    <div>
                    <IconButton color='primary' onClick={() => window.open(url,'_blank')}>
                        <OpenInNewIcon/>
                    </IconButton>
                    </div>
                    
                </SubHeader>
                <Divider/>
                </div>
        )
    }

            
}

export default ProjectProceduresListItem;